import { defineQuery } from 'next-sanity';

export const getCareersSetting = defineQuery(`
*[_type == "careersSetting"][0]{
  title,
  metaDescription,
  header,
  heroImage{
    ...,
    "imgAsset": asset-> {
      ...
    }
  },
  subtitle,
  section1Header,
  section1 {
    ...,
    column2Image[] {
      ...,
      "imgAsset": asset-> {
        ...
      }
    }
  },
  section2Header,
  section2 {
    ...,
    column2Image {
      ...,
      "imgAsset": asset-> {
        ...
      }
    }
  },
  section3Header,
  section3Content,
  section4Title,
  section4Content,
  section4Image {
    ...,
    "imgAsset": asset-> {
      ...
    }
  },
  section4Video,
  section5Header,
  section5 {
    ...,
    column1Image {
      ...,
      "imgAsset": asset-> {
        ...
      }
    }
  },
  CSS, JS
}
`);
export const getCareerPosition = defineQuery(`
*[_type == "careerType"]{
  title,
  slug  
}
`);
export const getCareerPositionDetail = defineQuery(`
*[_type == "careerType" && slug.current == $slug][0]{
  title,
  metaDescription,
  author->{
    name
  },
  editedDate,
  _createdAt,
  CSS, JS,
  content[]{
    ...,
    markDefs[]{...,
      _type == "internalLink" => { 
      "slug": @.reference->slug.current,
       "type":@.reference->_type     
       }
    },
    _type == "image" => {
      ...,
      asset-> {
        ...,
      }
    }
  },
  "text": pt::text(content),
  socialShare
}
`);

export const getCareerSeoData = defineQuery(`
   *[_type == "careersSetting"]{
   title,
    metaDescription,
   }
  `);

export const getCareerDetailSeoData = defineQuery(`
   *[_type == "careerType" && slug.current == $slug][0]{
   title,
   slug,
   metaDescription,
   content
   }
  `);

export const getAllCareersSlugs = defineQuery(`
  *[_type == "careerType" && defined(slug.current)][].slug.current`);
